@if (!currentGroup) {
  <h2>Gruppe auswählen</h2>
  <material-select-article [level]="1" (group)="setGroup($event)"></material-select-article>
}

@if (currentGroup) {
  @if (fieldsObservable.data$|async; as field) {
    <material-article-create-form-holder [articleFieldDefs]="field" [currentGroup]="currentGroup">
    </material-article-create-form-holder>
  } @else {
    <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
  }
  <loading-or-error
    #loadingOrError
    [loadingWrapper]="fieldsObservable"
    [errorMessage]="'Konnte Gruppe nicht laden'"
    [spinnerSize]="2"
    spinnerName="circle-o-notch">
  </loading-or-error>
}
